import Axios from "axios";
import { showMessage } from "jd-library/src/Toast/ToastAction";
import { getStore } from "../../../../store/createStore";
import { showHideLoader } from "../../../actions";
import { getMatchedUOM } from "../../../utills";
import { clickTrack, outDatedPricecardDataFetched, toggleOutDatedProductCardSlider } from "../../../actions/products";
import { getImagePath } from "../../productImageUtils";

export const getOutDatedPriceCardData = async (isFromCard = false, isLastProd = false) => {
    const dispatch = getStore().dispatch;
    const state = getStore().getState();
    !isFromCard && dispatch(clickTrack({ ll: 'digital_catalog', li: 'outdt_price',userBasedCheck: true }));
    dispatch(showHideLoader({ showLoader: true }));
    const { session: { token, profileObject }, uom: { productUOM } } = state;
    const params = {
        token,
        action: 'addPriceListing',
        pageNo: 1,
        smartCardFlag: 1
    }
    try {
        const apiRes = await Axios.get('/marketplace/static/php/web/b2bWebsite.php', { params });
        const data = apiRes.data
        if (data?.status) {
            const productData = data.data.productData?.map((item) => ({
                ...item,
                imageUrl: getImagePath(item.imageUrl, item.isTemplate),
                price: (item.categoryType?.toLowerCase() == "product" && item?.actual_price) ? Number(item?.actual_price).toString() : "" || "",
                actualPrice: (item.categoryType?.toLowerCase() == "service" && item?.actual_price) ? Number(item?.actual_price).toString() : "" || "",
                discPrice: (item.categoryType?.toLowerCase() == "service" && item?.discounted_price) ? Number(item?.discounted_price).toString() : "" || "",
                uom: null,
                error: '',
                showPriceRange: (item?.min_price || item?.max_price) ? true : false,
                priceObj: {
                    minPrice: item?.min_price ? Number(item?.min_price).toString() : "" || "",
                    maxPrice: item?.max_price ? Number(item?.max_price).toString() : "" || ""
                },
                uom: getMatchedUOM(productUOM, item?.unitOfMeasurement)
            }));
            let newProdAry = []
            if (productData.length) {
                newProdAry = productData;
            } else {
                if (!isLastProd) {
                    dispatch(showMessage({
                        showToastMessage: true,
                        message: `No ${profileObject.PluralLabelWithSpace} Found.`,
                        type: 'info',
                        duration: 5000
                    }));
                }
            }
            dispatch(outDatedPricecardDataFetched(newProdAry));
            dispatch(showHideLoader({ showLoader: false }));
            if (!isFromCard) {
                dispatch(toggleOutDatedProductCardSlider(true));
            }
        } else {
            dispatch(showMessage({
                showToastMessage: true,
                message: apiRes?.msg || `Unable to Fetch ${profileObject.PluralLabelWithSpace}. Please try again after some time.`,
                type: 'info',
                duration: 5000
            }));
            dispatch(showHideLoader({ showLoader: false }));
        }
    } catch (error) {
        dispatch(showMessage({
            showToastMessage: true,
            message: error?.message || 'Something went wrong, Please try again.',
            type: 'info',
            duration: 5000
        }));
        dispatch(showHideLoader({ showLoader: false }));
    }
}

export const updateOutdatedPriceCardData = async (productData, isUpdatePrice, isLastProd = false) => {
    try {
        const state = getStore().getState();
        const { session: { token } } = state;
        const params = {
            token,
            action: 'addPrice',
            smartCardFlag: 1,
            smartCardSource: 'OUTDATED_PRICE'
        }
        const payload = []
        const smartCardPrice = isUpdatePrice ? "1" : "0"
        let unitVal = ""
        if (productData?.uom?.val == "stds" || productData?.uom?.val == "Sess" || productData?.uom?.val == "Visit") {
            unitVal = productData?.unitOfMeasurement || ""
        } else {
            unitVal = productData?.uom?.val || ""
        }
        if (productData.showPriceRange && productData.priceObj.minPrice && productData.priceObj.maxPrice) {
            const obj = {
                productId: productData.productId,
                price_range: true,
                enquiry_price: '',
                unit: unitVal,
                categoryType: productData?.categoryType,
                smartCardPrice
            }
            if (isUpdatePrice) {
                obj.min_price = productData.priceObj.minPrice;
                obj.max_price = productData.priceObj.maxPrice;
            }
            payload.push(obj)
        } else if (!productData.showPriceRange) {
            const obj = {
                productId: productData.productId,
                price_range: false,
                min_price: '',
                max_price: '',
                unit: unitVal,
                categoryType: productData?.categoryType,
                smartCardPrice
            }

            if (isUpdatePrice) {
                if (productData?.categoryType == "product") {
                    obj.enquiry_price = productData.price;
                } else {
                    obj.actualPrice = productData.actualPrice;
                    obj.discPrice = productData.discPrice;
                }
            }
            payload.push(obj);
        }

        const formData = new FormData();
        formData.append('request', JSON.stringify(payload));
        const rsp = await Axios.post('/marketplace/static/php/web/b2bWebsite.php', formData, { params });
        const res = rsp.data
        if (res?.status===1) {
            getOutDatedPriceCardData(true, isLastProd)
            return { success: true, error: "" }
        } else if (res?.status === 3) {
            return {
                success: false,
                error: res?.msg,
                errData: res
            }
        } else {
            return { success: false, error: res?.msg || "Something went wrong" }
        }
    } catch (err) {
        return { success: false, error: err?.message || err?.msg || "Something went wrong" }
    }
}

export const debounceFunc = (func, delay) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}